var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17188 1.6875H2.39062C2.0023 1.6875 1.6875 2.0023 1.6875 2.39062V7.17188C1.6875 7.5602 2.0023 7.875 2.39062 7.875H7.17188C7.5602 7.875 7.875 7.5602 7.875 7.17188V2.39062C7.875 2.0023 7.5602 1.6875 7.17188 1.6875Z",
    stroke: "#F97D09",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6094 1.6875H10.8281C10.4398 1.6875 10.125 2.0023 10.125 2.39062V7.17188C10.125 7.5602 10.4398 7.875 10.8281 7.875H15.6094C15.9977 7.875 16.3125 7.5602 16.3125 7.17188V2.39062C16.3125 2.0023 15.9977 1.6875 15.6094 1.6875Z",
    stroke: "#F97D09",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17188 10.125H2.39062C2.0023 10.125 1.6875 10.4398 1.6875 10.8281V15.6094C1.6875 15.9977 2.0023 16.3125 2.39062 16.3125H7.17188C7.5602 16.3125 7.875 15.9977 7.875 15.6094V10.8281C7.875 10.4398 7.5602 10.125 7.17188 10.125Z",
    stroke: "#F97D09",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6094 10.125H10.8281C10.4398 10.125 10.125 10.4398 10.125 10.8281V15.6094C10.125 15.9977 10.4398 16.3125 10.8281 16.3125H15.6094C15.9977 16.3125 16.3125 15.9977 16.3125 15.6094V10.8281C16.3125 10.4398 15.9977 10.125 15.6094 10.125Z",
    stroke: "#F97D09",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/MenuIcon.0f82bd71bab8d287cca6d64832150473.svg";
export { ForwardRef as ReactComponent };